<template>
  <v-card flat>
    <v-card-title class="align-start mb-8">
      <span class="font-weight-semibold">Total de Tickets por Status</span>
    </v-card-title>
    <v-card-text>
      <div
        v-if="verifyData === 0"
        class="d-flex justify-center mt-10"
      >
        <span class="title font-weight-semibold overflow-auto">
          Nenhum dado disponível para gerar o gráfico
        </span>
      </div>

      <vue-apex-charts
        v-else
        ref="stackedBarChart"
        height="300"
        :options="chartOptionsStatus"
        :series="chartDataStatus"
        type="bar"
      ></vue-apex-charts>
    </v-card-text>
  </v-card>
</template>

<script>
import { getVuetify } from '@core/utils'
import VueApexCharts from 'vue-apexcharts'
import { ref, watch } from '@vue/composition-api'
import { converterDateStringEmLocaleDateString } from '@/utils/dateTime'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    dadosTicketsCategoriaStatus: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  setup(props) {
    const $vuetify = getVuetify()

    const chartOptionsStatus = ref({})
    const chartDataStatus = ref([])

    const stackedBarChart = ref(null)
    const verifyData = ref(0)

    function processData() {
      const data = props.dadosTicketsCategoriaStatus

      const categories = Array.from(
        new Set(data.map(item => converterDateStringEmLocaleDateString(item.dataCadastro))),
      )

      const statusTypes = Array.from(
        new Set(
          data.flatMap(item => item.categoriasStatus.map(status => status.nome)),
        ),
      )

      statusTypes.sort()

      const coresCategorias = {
        Novo: $vuetify.theme.currentTheme.success,
        Andamento: $vuetify.theme.currentTheme.warning,
        Resolvido: $vuetify.theme.currentTheme.error,
        Finalizado: $vuetify.theme.currentTheme.primary,
      }

      chartDataStatus.value = statusTypes.map(status => ({
        name: status,
        data: categories.map(date => {
          let total = 0
          const item = data.find(item => converterDateStringEmLocaleDateString(item.dataCadastro) === date)
          if (item) {
            const statusObj = item.categoriasStatus.find(s => s.nome === status)
            if (statusObj) {
              total = statusObj.total
            }
          }
          return total
        }),
      }))

      verifyData.value = chartDataStatus.value
        .flat()
        .reduce(
          (sum, series) => sum + series.data.reduce((a, b) => a + b, 0),
          0,
        )

      chartOptionsStatus.value = {
        chart: {
          type: 'bar',
          stacked: true,
        },
        colors: statusTypes.map(categoria => coresCategorias[categoria]),
        xaxis: {
          categories,
        },
        yaxis: {
          // ...
        },
        legend: {
          position: 'top',
        },
        fill: {
          opacity: 1,
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            columnWidth: '40%',
            dropShadow: {
              enabled: true,
              top: 1,
              left: 1,
              blur: 3,
              opacity: 0.2,
            },
          },
        },
      }
    }

    watch(
      () => props.dadosTicketsCategoriaStatus,
      processData,
      { immediate: true, deep: true },
    )

    return {
      stackedBarChart,
      chartDataStatus,
      chartOptionsStatus,
      verifyData,
    }
  },
}
</script>
